import { render, staticRenderFns } from "./price-edit.vue?vue&type=template&id=71ab9963&scoped=true"
import script from "./price-edit.vue?vue&type=script&lang=js"
export * from "./price-edit.vue?vue&type=script&lang=js"
import style0 from "./price-edit.vue?vue&type=style&index=0&id=71ab9963&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab9963",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ab9963')) {
      api.createRecord('71ab9963', component.options)
    } else {
      api.reload('71ab9963', component.options)
    }
    module.hot.accept("./price-edit.vue?vue&type=template&id=71ab9963&scoped=true", function () {
      api.rerender('71ab9963', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/units/components/price/price-edit.vue"
export default component.exports